import React, { useEffect, useRef, useState, useCallback } from "react";
import { get, post } from "../../services/api-services";
import { useParams } from "react-router-dom";
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Card, Divider, Paper, useTheme } from "@mui/material";
import ModuleHeading from "../../component/ModuleHeading";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AddPaymentDialog from "../../component/Case-Detail/profileModel-DialogBox/AddPaymentDialog";
import { StyledButton, StyledCancelButton } from "../../component/StyledComponent";
import { useCommon } from "../../context/CommonContext";

const InvoicePage = () => {
    const [invoiceData, setInvoiceData] = useState(null);
    const [paymentData, setPaymentData] = useState([]);
    const [addPayment, setAddPayment] = useState(false)
    const [remainingAmount, setRemainingAmount] = useState(0);
    const [netAmount, setNetAmount] = useState(0);
    const [sgst, setSgst] = useState(0);
    const [cgst, setCgst] = useState(0);
    const [invoiceNo, setInvoiceNum] = useState(null)
    const { invoiceId } = useParams();
    const { setSnackbar } = useCommon();
    const theme = useTheme();
    const logoUrl = theme.palette.mode === 'dark' ? '/whitelogo.png' : '/blacklogo.png';

    const fetchPayments = useCallback(async () => {
        if (!invoiceId) return;

        try {
            const url = `/UserPrograms?filter={"where":{"invoiceId":"${invoiceId}"},"include":["customer","invoice"]}`;
            const response = await get(url);

            if (response?.data?.length > 0) {
                const programData = response.data[0];
                setInvoiceData(programData);

                const enrollDate = new Date(programData?.invoice?.enrollOn);
                let lastNumR = '';
                const lengthR = programData?.invoice?.invoiceID?.toString()?.length;
                if (lengthR < 5) {
                    lastNumR = ('0000' + programData.invoice.invoiceID).slice(-5);
                }
                const invoiceNum = `WW${enrollDate.getFullYear().toString().substr(-2)}${("0" + (enrollDate.getMonth() + 1)).slice(-2)}${lastNumR}`;
                setInvoiceNum(invoiceNum)
                const programId = programData?.programId;
                const customerId = programData?.customerId;

                // Extract invoice details
                const invoice = programData?.invoice;
                const programPrice = invoice?.purchaseProgram?.price || 0;
                const feeDiscount = invoice?.feeDiscount || 0;
                const taxRate = invoice?.tax || 0;

                // Calculate discounted price and taxes
                const discountedPrice = programPrice - feeDiscount;
                const sgst = (discountedPrice * taxRate) / 200;
                const cgst = (discountedPrice * taxRate) / 200;
                const initialNetAmount = discountedPrice + sgst + cgst;
                let runningRemainingAmount = parseFloat((initialNetAmount).toFixed(2));
                // Initialize payment-related variables
                let totalPaidAmount = 0;

                if (programId && customerId) {
                    // Fetch payment data
                    const url1 = `/Payments?filter={"where":{"customerId":"${customerId}","programId":"${programId}","invoiceId":"${invoiceId}"},"order":"paidOn"}`;
                    const paymentResponse = await get(url1);
                    if (paymentResponse?.data) {
                        const payments = paymentResponse.data;

                        // Iterate and calculate remaining amount for each payment
                        const paymentsWithRemaining = payments.map((payment) => {
                            const remainingAmount = parseFloat((runningRemainingAmount - payment.amount).toFixed(2));
                            runningRemainingAmount = remainingAmount;
                            totalPaidAmount += payment.amount;

                            return {
                                ...payment,
                                remainingAmount: remainingAmount < 0 ? 0 : remainingAmount,
                            };
                        });

                        setPaymentData(paymentsWithRemaining);
                    }
                }
                const finalNetAmount = parseFloat((initialNetAmount).toFixed(2))
                const remainingAmount = parseFloat((finalNetAmount - totalPaidAmount).toFixed(2));
                setSgst(sgst);
                setCgst(cgst);
                setNetAmount(finalNetAmount);
                setRemainingAmount(remainingAmount);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }, [invoiceId]);

    useEffect(() => {
        fetchPayments();
    }, [fetchPayments]);

    const sendEmail = async () => {
        try {
            const apiUrl = `/UserPrograms?filter={"where":{"invoiceId":"${invoiceId}"},"include":["customer","invoice"]}`;
            const response = await get(apiUrl);
            const data = await response?.data;
            if (response?.statusCode !== 200) {
                alert("Failed to fetch data from the server.");
                return;
            }
            if (!data || !Array.isArray(data) || data?.length === 0) {
                alert("No data available for the given invoice ID.");
                return;
            }
            const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            data?.forEach(async (record) => {

                const enrollDate = new Date(record?.invoice?.enrollOn);
                const invoiceDate = `${month[enrollDate.getMonth()]} ${enrollDate.getDate()}, ${enrollDate.getFullYear()}`;

                const dueDate = new Date(record?.invoice?.dueDate);
                const due_date = `${month[dueDate.getMonth()]} ${dueDate.getDate()}, ${dueDate.getFullYear()}`;
                // Calculate discount and tax amounts
                const feeDiscount = record?.invoice?.feeDiscount || 0;
                const disAmt = record?.invoice?.purchaseProgram?.price - parseInt(feeDiscount);
                const invoiceTax = record?.invoice?.tax || 0
                const sgst = (invoiceTax) / 2;
                const sgstAmt = (disAmt * sgst) / 100;
                const cgstAmt = sgstAmt;
                const TaxAmt = (disAmt * invoiceTax) / 100;
                const netAmt = disAmt + TaxAmt;


                let lastNum = '';
                const length = record?.invoice?.invoiceID?.toString()?.length;

                if (length < 5) {
                    lastNum = ('0000' + record.invoice.invoiceID).slice(-5);

                }
                const invoiceNum = `WW${enrollDate.getFullYear().toString().substr(-2)}${("0" + (enrollDate.getMonth() + 1)).slice(-2)}${lastNum}`;

                // Prepare payload for sending email
                const payload = { title: "Weight Wonder", invoiceId: invoiceNum, invoiceDate: invoiceDate, invoiceStatus: data[0]?.invoice?.status, dueDate: due_date, customerName: data[0]?.customer?.name, customerMobile: data[0]?.customer.mobile, customerEmail: data[0]?.customer?.email, customerAddress: data[0]?.customer?.address, companyName: "WeightWonder™", companyContactNumber: "+915588779933", companyEmail: "info@weightwonder.com", companyAddress: "27-Noble Plaza, MP Nagar Bhopal", programName: record.invoice.purchaseProgram.title, programPrice: record.invoice.purchaseProgram.price, programDiscount: feeDiscount, sgst: sgst, sgstAmt: sgstAmt, cgst: cgst, cgstAmt: cgstAmt, netAmt: netAmt, senderEmailId: data[0]?.customer?.email, username: data[0]?.customer.name };
                // Send email
                const apiResponse = await post('/Invoices/sendInvoice', payload);

                if (apiResponse?.statusCode === 200) {
                    setSnackbar({
                        openSnackbar: true,
                        message: 'Email sent successfully',
                        severity: 'success'
                    });
                } else {
                    setSnackbar({
                        openSnackbar: true,
                        message: 'Failed to send email',
                        severity: 'error'
                    });

                }
            });
        } catch (error) {
            console.error("Error in sending email:", error);
            alert("An error occurred while sending the email.");
        }
    };

    if (!invoiceData) return <Typography align="center">Loading...</Typography>;

    const { customer, invoice } = invoiceData;

    const handleClickAddPayment = () => {
        setAddPayment(true);
    }
    const handlePaymentClose = () => {
        setAddPayment(false);
    }


    const handlePrint = () => {
        const unwantedElements = document.querySelectorAll('header, footer, .vite-logo, .timestamp, .url'); // Add more selectors if needed
        unwantedElements.forEach(element => {
            element.style.display = 'none';
        });
        const printContent = document.getElementById('invoice-print-section').innerHTML;
        let printOverlay = document.getElementById('print-overlay');

        if (!printOverlay) {
            printOverlay = document.createElement('div');
            printOverlay.id = 'print-overlay';
            printOverlay.style.position = 'fixed';
            printOverlay.style.top = 0;
            printOverlay.style.left = 0;
            printOverlay.style.width = '100%';
            printOverlay.style.height = '100%';
            printOverlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
            printOverlay.style.zIndex = 9999;
            printOverlay.style.display = 'flex';
            printOverlay.style.justifyContent = 'center';
            printOverlay.style.alignItems = 'center';
        } else {
            printOverlay.innerHTML = '';
        }
        const printContainer = document.createElement('div');
        printContainer.innerHTML = printContent;
        printContainer.style.backgroundColor = 'white';
        printContainer.style.padding = '20px';
        printContainer.style.borderRadius = '10px';
        printOverlay.appendChild(printContainer);
        document.body.appendChild(printOverlay);
        window.print();
        printOverlay.remove();
        unwantedElements.forEach(element => {
            element.style.display = '';
        });
    };


    return (
        <Box>
            <ModuleHeading title="Invoice details" navigateTo={invoiceData?.customerId ? `/admin/cases/caseDetails/${invoiceData.customerId}?tab=2` : "/admin/cases"} />
            <Box id="invoice-print-section">
                <Card>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "16px",
                            // backgroundColor: "#fff",
                        }}
                    >
                        <Box>
                            <Typography variant="subtitle1"><strong>Invoice:</strong>{invoiceNo}</Typography>
                            <Typography variant="subtitle2" >
                                {new Date(invoice?.enrollOn).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                })}
                            </Typography>

                            {invoice?.status === "Paid" ? (
                                <Typography variant="h6" color="green">✓ PAID</Typography>
                            ) : (
                                <Typography variant="h6" className="w-600 bold-text">
                                    <strong style={{ color: 'red' }}>
                                        <AccessTimeIcon /> PAYMENT DUE
                                    </strong>: ₹{remainingAmount}
                                </Typography>

                            )}

                        </Box>
                        <Box textAlign="right">
                            <img src={logoUrl} alt="Weight Wonder Logo" style={{ maxWidth: "150px", height: "auto" }} />
                            <Typography variant="subtitle2">
                                <strong style={{ color: '#888888' }}>Payment Due Date:</strong>{" "}
                                {new Date(invoice?.dueDate).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                })}
                            </Typography>


                        </Box>
                    </Box>
                    <Divider />
                    {/* Customer Details */}
                    <Paper className="flex justify-between items-center p-4">
                        <Box>
                            <Typography variant="subtitle1"><strong>{customer?.name}</strong></Typography>
                            <Typography variant="body2"> {customer?.mobile}</Typography>
                            <Typography variant="body2"> {customer?.email}</Typography>
                            <Typography variant="body2"> {customer?.address}</Typography>
                        </Box>
                        <Box textAlign="right">
                            <Typography variant="body2">WeightWonder™</Typography>
                            <Typography variant="body2">+915588779933</Typography>
                            <Typography variant="body2">info@weightwonder.com</Typography>
                            <Typography variant="subtitle2">27-Noble Plaza, MP Nagar Bhopal</Typography>

                        </Box>
                    </Paper>
                    <Divider />


                    {/* Program Details */}
                    <Box className="flex justify-between items-center p-4" >
                        <Box>
                            <Typography variant="subtitle1">WeightWonder™{invoice?.purchaseProgram?.title}</Typography>

                        </Box>
                        <Box textAlign="right">
                            <Typography variant="body2">Price: ₹{invoice?.purchaseProgram?.price}</Typography>
                        </Box>
                    </Box>
                    <Divider />

                    {invoice?.feeDiscount ? (
                        <Box className="flex justify-between items-center p-4  " >
                            <Box>
                                <Typography >Discount</Typography>
                            </Box>
                            <Box textAlign="right">
                                <Typography variant="body2">
                                    <strong>-₹{invoice.feeDiscount}</strong>
                                </Typography>
                            </Box>

                        </Box>
                    ) : null}


                    {invoiceData?.invoice?.tax ? (
                        <Box className="flex justify-between items-center p-4 " >
                            <Box>
                                <Typography >S-GST -  {(invoice?.tax) / 2}%</Typography>
                                <Typography >C-GST - {(invoice?.tax) / 2}%</Typography>
                            </Box>
                            <Box textAlign="right">
                                <Typography variant="body2">
                                    {sgst.toFixed(2)}
                                </Typography>
                                <Typography variant="body2">
                                    {cgst.toFixed(2)}
                                </Typography>
                            </Box>

                        </Box>
                    ) : null}

                    <Divider />


                    <Box className="flex justify-between items-center p-4">
                        <Box>
                            <Typography variant="h6"><strong>Net Amount{invoiceData?.price}</strong></Typography>

                        </Box>
                        <Box textAlign="right">
                            <Typography variant="body2"><strong>₹{netAmount}</strong> </Typography>
                        </Box>
                    </Box>
                    <Divider />


                    {/* Buttons */}

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "16px",
                        }}
                    >
                        <Box>
                        </Box>
                        <Box textAlign="right" className="text-right flex gap-4 mb-5">
                            <StyledCancelButton variant="outlined"
                                onClick={handlePrint} >
                                Print
                            </StyledCancelButton>
                            <StyledCancelButton variant="outlined"
                                onClick={sendEmail}>
                                E-mail
                            </StyledCancelButton>
                            {invoice?.status === "Due" && (
                                <StyledButton variant="contained" color="secondary"
                                    onClick={handleClickAddPayment}>
                                    Add Payment
                                </StyledButton>
                            )}
                        </Box>

                    </Box>
                    <Divider />

                </Card >
                {paymentData.length > 0 && (
                    <>
                        <Typography variant="h6" gutterBottom paddingTop={5}>
                            <strong>Invoice Summary</strong>
                        </Typography>
                        <TableContainer>
                            <Table
                                sx={{
                                    border: '1px solid rgba(0, 0, 0, 0.12)',
                                }}
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            sx={{
                                                borderRight: '1px solid rgba(0, 0, 0, 0.12)',
                                                padding: '4px 8px',
                                                textAlign: 'center',
                                            }}
                                        >
                                            Paid On
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                borderRight: '1px solid rgba(0, 0, 0, 0.12)',
                                                padding: '4px 8px',
                                                textAlign: 'center',
                                            }}
                                        >
                                            Paid Amount
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                borderRight: '1px solid rgba(0, 0, 0, 0.12)',
                                                padding: '4px 8px',
                                                textAlign: 'center',
                                            }}
                                        >
                                            Remaining Amount
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                borderRight: '1px solid rgba(0, 0, 0, 0.12)',
                                                padding: '4px 8px',
                                                textAlign: 'center',
                                            }}
                                        >
                                            Payment Mode
                                        </TableCell>
                                        <TableCell sx={{ padding: '4px 8px', textAlign: 'center', }}>Comment</TableCell> {/* Reduced padding */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paymentData.reverse().map((payment, index) => (
                                        <TableRow key={index}>
                                            <TableCell
                                                sx={{
                                                    borderRight: '1px solid rgba(0, 0, 0, 0.12)',
                                                    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                                                    padding: '4px 8px',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                {new Date(payment?.paidOn).toLocaleDateString()}
                                            </TableCell>
                                            <TableCell
                                                sx={{
                                                    borderRight: '1px solid rgba(0, 0, 0, 0.12)',
                                                    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                                                    padding: '4px 8px',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                ₹{payment?.amount || '0'}
                                            </TableCell>
                                            <TableCell
                                                sx={{
                                                    borderRight: '1px solid rgba(0, 0, 0, 0.12)',
                                                    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                                                    padding: '4px 8px',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                ₹{payment?.remainingAmount || '0'}

                                            </TableCell>
                                            <TableCell
                                                sx={{
                                                    borderRight: '1px solid rgba(0, 0, 0, 0.12)',
                                                    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                                                    padding: '4px 8px',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                {payment?.paymentMode || 'N/A'}
                                            </TableCell>
                                            <TableCell
                                                sx={{
                                                    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                                                    padding: '4px 8px',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                {payment?.comment || '-'}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                )}
            </Box>

            < AddPaymentDialog
                open={addPayment}
                onClose={handlePaymentClose}
                existingProgramData={invoiceData ? { ...invoiceData, remainingAmount, remainAmount: remainingAmount, dueAmount: remainingAmount } : null}
                fetchPayments={fetchPayments}
            />
        </Box >
    );
};

export default InvoicePage;


